export default __webpack_public_path__ + "static/consistent-header-slide-out-drawers-5236002bd2a315e315ce5b7f4262b8c6.png";